import { render, staticRenderFns } from "./TableSkeleton.vue?vue&type=template&id=ef3d6436&scoped=true&"
import script from "./TableSkeleton.vue?vue&type=script&lang=js&"
export * from "./TableSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./TableSkeleton.vue?vue&type=style&index=0&id=ef3d6436&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef3d6436",
  null
  
)

export default component.exports